function n(t){return e=>{customElements.get(t)||customElements.define(t,e)}}function s(t){return e=>{e.prototype.cssStyles=t}}export{n as a,s as b};
